module.exports = __webpack_public_path__ + "static/media/close-modal-icon.24e5d7ba.svg";